import React, { useEffect } from "react";
import { getBanners } from "../../../../redux/app/actions";
import { useDispatch } from "react-redux";

import { MetaTags } from "react-meta-tags";
import Sports from "../../privatePages/sports";
import { useSearchParams } from "react-router-dom";
import UseAppendScript from "../../../../hooks/useAppendScript";
import { APP_CONST } from "../../../../config/const";
import { addMetaTags } from "../../../../utils/addMetaTags";
const LandingPage = () => {
  const dispatch = useDispatch();
  const appendScript = UseAppendScript("live-chat");
  const [searchParams, setSearchParams] = useSearchParams();
  let isApk = searchParams.get("apk") === "true";

  useEffect(() => {
    if (isApk) {
      localStorage.setItem("isApk", true);
    }
  }, [isApk]);

  useEffect(() => {
    dispatch(getBanners());
    appendScript(APP_CONST.LIVE_CHAT_SCRIPT);
    addMetaTags({
      title:
        "Best Online Betting Website In India | Online Sports Betting  - Dial4Bet",
      content:
        "Welcome to Dial4Bet - your premier online betting site in India. Explore exciting online gambling site and enjoy thrilling experiences. Bet now and win big!",
    });
  }, []);

  return (
    <>
      <div
        dangerouslySetInnerHTML={{
          __html: `<script type="application/ld+json">
          {
            "@context": "http://schema.org/",
            "@type": "WebSite",
            "url": " https://www.dial4bet.com/landing-page ",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "{search_term_string}",
              "query-input": "required name=search_term_string"
            }
          }
          </script>
          `,
        }}
      ></div>
      {/* <MetaTags>
        <title>
          Best Sports Betting online, Fantasy Sports in India – Dial4bet
        </title>
        <meta
          id="landing-page-meta"
          name="description"
          content="Dial4bet provide Best Fantasy Sports Betting online. Find Best Fantasy sports betting online India at Dial4bet
"
        />
        <meta
          name="keywords"
          content="best sports betting online, fantasy sports in india, fantasy sports betting online"
        />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content=" Best Sports Betting online, Fantasy Sports in India – Dial4bet"
        />
        <meta
          property="og:description"
          content=" Dial4bet provide Best Fantasy Sports Betting online. Find Best Fantasy sports betting online India at Dial4bet"
        />
        <meta
          property="og:url"
          content="https://www.dial4bet.com/landing-page"
        />
        <meta property="og:site_name" content="Dial4bet" />
        <meta
          property="og:image"
          content="https://d2u5fi4tsqd4lz.cloudfront.net/4a8fde3c-bcb7-43ce-9532-2d36c8c81582.png"
        />
      </MetaTags> */}
      {/* <Header /> */}
      <Sports />
    </>
  );
};
export default LandingPage;
